var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ele-gallery',_vm._b({staticStyle:{"line-height":"1em"},attrs:{"sliceSingle":true,"source":_vm.displayValue,"title":_vm.title}},'ele-gallery',_vm.attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }